import Entities from "../../entities";
import {EntityMapper} from "../../@types/entity";

import * as AccountingConnectionActions from "./accountingConnectionActions";
import * as ActivityCategoryActions from "./activityCategoryActions";
import * as ActivityTypeActions from "./activityTypeActions";
import * as AddressActions from "./addressActions";
import * as AnswerActions from "./answerActions";
import * as BankAccountActions from "./bankAccountActions";
import * as BlackoutActions from "./blackoutActions";
import * as CampaignActions from "./campaignActions";
import * as CaseTypeActions from "./caseTypeActions";
import * as CaseTypeStageActions from "./caseTypeStageActions";
import * as CategoryActions from "./categoryActions";
import * as CommentActions from "./commentActions";
import * as ConflictActions from "./conflictActions";
import * as ContactActions from "./contactActions";
import * as CourtActions from "./courtActions";
import * as CourtDeadlineRuleActions from "./courtDeadlineRuleActions";
import * as DeadlineActions from "./deadlineActions";
import * as DeadlineRuleActions from "./deadlineRuleActions";
import * as DiscountActions from "./discountActions";
import * as DocketActions from "./docketActions";
import * as DocumentActions from "./documentActions";
import * as EntityTimestampActions from "./entityTimestampActions";
import * as EventActions from "./eventActions";
import * as ExpenseActions from "./expenseActions";
import * as FirmActions from "./firmActions";
import * as FlatFeeActions from "./flatFeeActions";
import * as FlatFeeMilestoneActions from "./flatFeeMilestoneActions";
import * as GroupActions from "./groupActions";
import * as HolidayCalendarActions from "./holidayCalendarActions";
import * as IdentificationActions from "./identificationActions";
import * as ImportExportActions from "./importExportActions";
import * as ImportSourceActions from "./importSourceActions";
import * as InvoiceActions from "./invoiceActions";
import * as InvoiceBatchActions from "./invoiceBatchActions";
import * as InvoiceBatchItemActions from "./invoiceBatchItemActions";
import * as LeadActions from "./leadActions";
import * as LookupActions from "./lookupActions";
import * as MatterActions from "./matterActions";
import * as MatterStageActions from "./matterStageActions";
import * as MilestoneActions from "./milestoneActions";
import * as OptionActions from "./optionActions";
import * as ParticipantActions from "./participantActions";
import * as PrivilegeActions from "./privilegeActions";
import * as QuestionActions from "./questionActions";
import * as RedFlagActions from "./redFlagActions";
import * as RedFlagTypeActions from "./redFlagTypeActions";
import * as ReferralActions from "./referralActions";
import * as ResourceActions from "./resourceActions";
import * as RoleActions from "./roleActions";
import * as TaskActions from "./taskActions";
import * as TemplateTaskActions from "./templateTaskActions";
import * as TimeOffActions from "./timeOffActions";
import * as TransactionActions from "./transactionActions";
import * as UserActions from "./userActions";
import {deleteAccountingConnection} from '../deps/accountingConnectionDeps';
import {deleteActivityCategory} from '../deps/activityCategoryDeps';
import {deleteActivityType} from '../deps/activityTypeDeps';
import {deleteAddress} from '../deps/addressDeps';
import {deleteAnswer} from '../deps/answerDeps';
import {deleteBankAccount} from '../deps/bankAccountDeps';
import {deleteBlackout} from '../deps/blackoutDeps';
import {deleteCampaign} from '../deps/campaignDeps';
import {deleteCaseTypeStage} from '../deps/caseTypeStageDeps';
import {deleteCaseType} from '../deps/caseTypeDeps';
import {deleteCategory} from '../deps/categoryDeps';
import {deleteComment} from '../deps/commentDeps';
import {deleteConflict} from '../deps/conflictDeps';
import {deleteContact} from '../deps/contactDeps';
import {deleteCourtDeadlineRule} from '../deps/courtDeadlineRuleDeps';
import {deleteCourt} from '../deps/courtDeps';
import {deleteDeadlineRule} from '../deps/deadlineRuleDeps';
import {deleteDeadline} from '../deps/deadlineDeps';
import {deleteDiscount} from '../deps/discountDeps';
import {deleteDocket} from '../deps/docketDeps';
import {deleteDocument} from '../deps/documentDeps';
import {deleteEntityTimestamp} from '../deps/entityTimestampDeps';
import {deleteEvent} from '../deps/eventDeps';
import {deleteExpense} from '../deps/expenseDeps';
import {deleteFirm} from '../deps/firmDeps';
import {deleteFlatFeeMilestone} from '../deps/flatFeeMilestoneDeps';
import {deleteFlatFee} from '../deps/flatFeeDeps';
import {deleteGroup} from '../deps/groupDeps';
import {deleteHolidayCalendar} from '../deps/holidayCalendarDeps';
import {deleteIdentification} from '../deps/identificationDeps';
import {deleteImportExport} from '../deps/importExportDeps';
import {deleteImportSource} from '../deps/importSourceDeps';
import {deleteInvoiceBatchItem} from '../deps/invoiceBatchItemDeps';
import {deleteInvoiceBatch} from '../deps/invoiceBatchDeps';
import {deleteInvoice} from '../deps/invoiceDeps';
import {deleteLead} from '../deps/leadDeps';
import {deleteLookup} from '../deps/lookupDeps';
import {deleteMatterStage} from '../deps/matterStageDeps';
import {deleteMatter} from '../deps/matterDeps';
import {deleteMilestone} from '../deps/milestoneDeps';
import {deleteOption} from '../deps/optionDeps';
import {deleteParticipant} from '../deps/participantDeps';
import {deletePrivilege} from '../deps/privilegeDeps';
import {deleteQuestion} from '../deps/questionDeps';
import {deleteRedFlagType} from '../deps/redFlagTypeDeps';
import {deleteRedFlag} from '../deps/redFlagDeps';
import {deleteReferral} from '../deps/referralDeps';
import {deleteResource} from '../deps/resourceDeps';
import {deleteRole} from '../deps/roleDeps';
import {deleteTask} from '../deps/taskDeps';
import {deleteTemplateTask} from '../deps/templateTaskDeps';
import {deleteTimeOff} from '../deps/timeOffDeps';
import {deleteTransaction} from '../deps/transactionDeps';
import {deleteUser} from '../deps/userDeps';

const ENTITIES: EntityMapper<any>[] = [
	{
		name: 'accountingConnection',
		plural: 'accountingConnections',
		clazz: Entities.AccountingConnection,
		table: 'ACCOUNTING_CONNECTION',
		fetchOneQueue: AccountingConnectionActions.fetchOneAccountingConnectionQueue,
		fetchOneSuccess: AccountingConnectionActions.fetchOneAccountingConnectionSuccess,
		fetchOneFailure: AccountingConnectionActions.fetchOneAccountingConnectionFailure,
		fetchSuccess: AccountingConnectionActions.fetchAccountingConnectionSuccess,
		fetchFailure: AccountingConnectionActions.fetchAccountingConnectionFailure,
		saveSuccess: AccountingConnectionActions.saveAccountingConnectionSuccess,
		saveFailure: AccountingConnectionActions.saveAccountingConnectionFailure,
		saveManySuccess: AccountingConnectionActions.saveManyAccountingConnectionsSuccess,
		saveManyFailure: AccountingConnectionActions.saveManyAccountingConnectionsFailure,
		removeSuccess: AccountingConnectionActions.removeAccountingConnectionSuccess,
		removeFailure: AccountingConnectionActions.removeAccountingConnectionFailure,
		restoreSuccess: AccountingConnectionActions.restoreAccountingConnectionSuccess,
		restoreFailure: AccountingConnectionActions.restoreAccountingConnectionFailure,
		save: AccountingConnectionActions.saveAccountingConnection,
		saveQueue: AccountingConnectionActions.saveAccountingConnectionQueue,
		saveMany: AccountingConnectionActions.saveManyAccountingConnections,
		saveManyQueue: AccountingConnectionActions.saveManyAccountingConnectionsQueue,
		remove: AccountingConnectionActions.removeAccountingConnection,
		removeQueue: AccountingConnectionActions.removeAccountingConnectionQueue,
		restore: AccountingConnectionActions.restoreAccountingConnection,
		restoreQueue: AccountingConnectionActions.restoreAccountingConnectionQueue,
		restoreMany: AccountingConnectionActions.restoreManyAccountingConnections,
		removeMany: AccountingConnectionActions.removeManyAccountingConnections,
		delete: deleteAccountingConnection
	},
	{
		name: 'activityCategory',
		plural: 'activityCategories',
		clazz: Entities.ActivityCategory,
		table: 'ACTIVITY_CATEGORY',
		fetchOneQueue: ActivityCategoryActions.fetchOneActivityCategoryQueue,
		fetchOneSuccess: ActivityCategoryActions.fetchOneActivityCategorySuccess,
		fetchOneFailure: ActivityCategoryActions.fetchOneActivityCategoryFailure,
		fetchSuccess: ActivityCategoryActions.fetchActivityCategorySuccess,
		fetchFailure: ActivityCategoryActions.fetchActivityCategoryFailure,
		saveSuccess: ActivityCategoryActions.saveActivityCategorySuccess,
		saveFailure: ActivityCategoryActions.saveActivityCategoryFailure,
		saveManySuccess: ActivityCategoryActions.saveManyActivityCategoriesSuccess,
		saveManyFailure: ActivityCategoryActions.saveManyActivityCategoriesFailure,
		removeSuccess: ActivityCategoryActions.removeActivityCategorySuccess,
		removeFailure: ActivityCategoryActions.removeActivityCategoryFailure,
		restoreSuccess: ActivityCategoryActions.restoreActivityCategorySuccess,
		restoreFailure: ActivityCategoryActions.restoreActivityCategoryFailure,
		save: ActivityCategoryActions.saveActivityCategory,
		saveQueue: ActivityCategoryActions.saveActivityCategoryQueue,
		saveMany: ActivityCategoryActions.saveManyActivityCategories,
		saveManyQueue: ActivityCategoryActions.saveManyActivityCategoriesQueue,
		remove: ActivityCategoryActions.removeActivityCategory,
		removeQueue: ActivityCategoryActions.removeActivityCategoryQueue,
		restore: ActivityCategoryActions.restoreActivityCategory,
		restoreQueue: ActivityCategoryActions.restoreActivityCategoryQueue,
		restoreMany: ActivityCategoryActions.restoreManyActivityCategories,
		removeMany: ActivityCategoryActions.removeManyActivityCategories,
		delete: deleteActivityCategory
	},
	{
		name: 'activityType',
		plural: 'activityTypes',
		clazz: Entities.ActivityType,
		table: 'ACTIVITY_TYPE',
		fetchOneQueue: ActivityTypeActions.fetchOneActivityTypeQueue,
		fetchOneSuccess: ActivityTypeActions.fetchOneActivityTypeSuccess,
		fetchOneFailure: ActivityTypeActions.fetchOneActivityTypeFailure,
		fetchSuccess: ActivityTypeActions.fetchActivityTypeSuccess,
		fetchFailure: ActivityTypeActions.fetchActivityTypeFailure,
		saveSuccess: ActivityTypeActions.saveActivityTypeSuccess,
		saveFailure: ActivityTypeActions.saveActivityTypeFailure,
		saveManySuccess: ActivityTypeActions.saveManyActivityTypesSuccess,
		saveManyFailure: ActivityTypeActions.saveManyActivityTypesFailure,
		removeSuccess: ActivityTypeActions.removeActivityTypeSuccess,
		removeFailure: ActivityTypeActions.removeActivityTypeFailure,
		restoreSuccess: ActivityTypeActions.restoreActivityTypeSuccess,
		restoreFailure: ActivityTypeActions.restoreActivityTypeFailure,
		save: ActivityTypeActions.saveActivityType,
		saveQueue: ActivityTypeActions.saveActivityTypeQueue,
		saveMany: ActivityTypeActions.saveManyActivityTypes,
		saveManyQueue: ActivityTypeActions.saveManyActivityTypesQueue,
		remove: ActivityTypeActions.removeActivityType,
		removeQueue: ActivityTypeActions.removeActivityTypeQueue,
		restore: ActivityTypeActions.restoreActivityType,
		restoreQueue: ActivityTypeActions.restoreActivityTypeQueue,
		restoreMany: ActivityTypeActions.restoreManyActivityTypes,
		removeMany: ActivityTypeActions.removeManyActivityTypes,
		delete: deleteActivityType
	},
	{
		name: 'address',
		plural: 'addresses',
		clazz: Entities.Address,
		table: 'ADDRESS',
		fetchOneQueue: AddressActions.fetchOneAddressQueue,
		fetchOneSuccess: AddressActions.fetchOneAddressSuccess,
		fetchOneFailure: AddressActions.fetchOneAddressFailure,
		fetchSuccess: AddressActions.fetchAddressSuccess,
		fetchFailure: AddressActions.fetchAddressFailure,
		saveSuccess: AddressActions.saveAddressSuccess,
		saveFailure: AddressActions.saveAddressFailure,
		saveManySuccess: AddressActions.saveManyAddressesSuccess,
		saveManyFailure: AddressActions.saveManyAddressesFailure,
		removeSuccess: AddressActions.removeAddressSuccess,
		removeFailure: AddressActions.removeAddressFailure,
		restoreSuccess: AddressActions.restoreAddressSuccess,
		restoreFailure: AddressActions.restoreAddressFailure,
		save: AddressActions.saveAddress,
		saveQueue: AddressActions.saveAddressQueue,
		saveMany: AddressActions.saveManyAddresses,
		saveManyQueue: AddressActions.saveManyAddressesQueue,
		remove: AddressActions.removeAddress,
		removeQueue: AddressActions.removeAddressQueue,
		restore: AddressActions.restoreAddress,
		restoreQueue: AddressActions.restoreAddressQueue,
		restoreMany: AddressActions.restoreManyAddresses,
		removeMany: AddressActions.removeManyAddresses,
		delete: deleteAddress
	},
	{
		name: 'answer',
		plural: 'answers',
		clazz: Entities.Answer,
		table: 'ANSWER',
		fetchOneQueue: AnswerActions.fetchOneAnswerQueue,
		fetchOneSuccess: AnswerActions.fetchOneAnswerSuccess,
		fetchOneFailure: AnswerActions.fetchOneAnswerFailure,
		fetchSuccess: AnswerActions.fetchAnswerSuccess,
		fetchFailure: AnswerActions.fetchAnswerFailure,
		saveSuccess: AnswerActions.saveAnswerSuccess,
		saveFailure: AnswerActions.saveAnswerFailure,
		saveManySuccess: AnswerActions.saveManyAnswersSuccess,
		saveManyFailure: AnswerActions.saveManyAnswersFailure,
		removeSuccess: AnswerActions.removeAnswerSuccess,
		removeFailure: AnswerActions.removeAnswerFailure,
		restoreSuccess: AnswerActions.restoreAnswerSuccess,
		restoreFailure: AnswerActions.restoreAnswerFailure,
		save: AnswerActions.saveAnswer,
		saveQueue: AnswerActions.saveAnswerQueue,
		saveMany: AnswerActions.saveManyAnswers,
		saveManyQueue: AnswerActions.saveManyAnswersQueue,
		remove: AnswerActions.removeAnswer,
		removeQueue: AnswerActions.removeAnswerQueue,
		restore: AnswerActions.restoreAnswer,
		restoreQueue: AnswerActions.restoreAnswerQueue,
		restoreMany: AnswerActions.restoreManyAnswers,
		removeMany: AnswerActions.removeManyAnswers,
		delete: deleteAnswer
	},
	{
		name: 'bankAccount',
		plural: 'bankAccounts',
		clazz: Entities.BankAccount,
		table: 'BANK_ACCOUNT',
		fetchOneQueue: BankAccountActions.fetchOneBankAccountQueue,
		fetchOneSuccess: BankAccountActions.fetchOneBankAccountSuccess,
		fetchOneFailure: BankAccountActions.fetchOneBankAccountFailure,
		fetchSuccess: BankAccountActions.fetchBankAccountSuccess,
		fetchFailure: BankAccountActions.fetchBankAccountFailure,
		saveSuccess: BankAccountActions.saveBankAccountSuccess,
		saveFailure: BankAccountActions.saveBankAccountFailure,
		saveManySuccess: BankAccountActions.saveManyBankAccountsSuccess,
		saveManyFailure: BankAccountActions.saveManyBankAccountsFailure,
		removeSuccess: BankAccountActions.removeBankAccountSuccess,
		removeFailure: BankAccountActions.removeBankAccountFailure,
		restoreSuccess: BankAccountActions.restoreBankAccountSuccess,
		restoreFailure: BankAccountActions.restoreBankAccountFailure,
		save: BankAccountActions.saveBankAccount,
		saveQueue: BankAccountActions.saveBankAccountQueue,
		saveMany: BankAccountActions.saveManyBankAccounts,
		saveManyQueue: BankAccountActions.saveManyBankAccountsQueue,
		remove: BankAccountActions.removeBankAccount,
		removeQueue: BankAccountActions.removeBankAccountQueue,
		restore: BankAccountActions.restoreBankAccount,
		restoreQueue: BankAccountActions.restoreBankAccountQueue,
		restoreMany: BankAccountActions.restoreManyBankAccounts,
		removeMany: BankAccountActions.removeManyBankAccounts,
		delete: deleteBankAccount
	},
	{
		name: 'blackout',
		plural: 'blackouts',
		clazz: Entities.Blackout,
		table: 'BLACKOUT',
		fetchOneQueue: BlackoutActions.fetchOneBlackoutQueue,
		fetchOneSuccess: BlackoutActions.fetchOneBlackoutSuccess,
		fetchOneFailure: BlackoutActions.fetchOneBlackoutFailure,
		fetchSuccess: BlackoutActions.fetchBlackoutSuccess,
		fetchFailure: BlackoutActions.fetchBlackoutFailure,
		saveSuccess: BlackoutActions.saveBlackoutSuccess,
		saveFailure: BlackoutActions.saveBlackoutFailure,
		saveManySuccess: BlackoutActions.saveManyBlackoutsSuccess,
		saveManyFailure: BlackoutActions.saveManyBlackoutsFailure,
		removeSuccess: BlackoutActions.removeBlackoutSuccess,
		removeFailure: BlackoutActions.removeBlackoutFailure,
		restoreSuccess: BlackoutActions.restoreBlackoutSuccess,
		restoreFailure: BlackoutActions.restoreBlackoutFailure,
		save: BlackoutActions.saveBlackout,
		saveQueue: BlackoutActions.saveBlackoutQueue,
		saveMany: BlackoutActions.saveManyBlackouts,
		saveManyQueue: BlackoutActions.saveManyBlackoutsQueue,
		remove: BlackoutActions.removeBlackout,
		removeQueue: BlackoutActions.removeBlackoutQueue,
		restore: BlackoutActions.restoreBlackout,
		restoreQueue: BlackoutActions.restoreBlackoutQueue,
		restoreMany: BlackoutActions.restoreManyBlackouts,
		removeMany: BlackoutActions.removeManyBlackouts,
		delete: deleteBlackout
	},
	{
		name: 'category',
		plural: 'categories',
		clazz: Entities.Category,
		table: 'CATEGORY',
		fetchOneQueue: CategoryActions.fetchOneCategoryQueue,
		fetchOneSuccess: CategoryActions.fetchOneCategorySuccess,
		fetchOneFailure: CategoryActions.fetchOneCategoryFailure,
		fetchSuccess: CategoryActions.fetchCategorySuccess,
		fetchFailure: CategoryActions.fetchCategoryFailure,
		saveSuccess: CategoryActions.saveCategorySuccess,
		saveFailure: CategoryActions.saveCategoryFailure,
		saveManySuccess: CategoryActions.saveManyCategoriesSuccess,
		saveManyFailure: CategoryActions.saveManyCategoriesFailure,
		removeSuccess: CategoryActions.removeCategorySuccess,
		removeFailure: CategoryActions.removeCategoryFailure,
		restoreSuccess: CategoryActions.restoreCategorySuccess,
		restoreFailure: CategoryActions.restoreCategoryFailure,
		save: CategoryActions.saveCategory,
		saveQueue: CategoryActions.saveCategoryQueue,
		saveMany: CategoryActions.saveManyCategories,
		saveManyQueue: CategoryActions.saveManyCategoriesQueue,
		remove: CategoryActions.removeCategory,
		removeQueue: CategoryActions.removeCategoryQueue,
		restore: CategoryActions.restoreCategory,
		restoreQueue: CategoryActions.restoreCategoryQueue,
		restoreMany: CategoryActions.restoreManyCategories,
		removeMany: CategoryActions.removeManyCategories,
		delete: deleteCategory
	},
	{
		name: 'campaign',
		plural: 'campaigns',
		clazz: Entities.Campaign,
		table: 'CAMPAIGN',
		fetchOneQueue: CampaignActions.fetchOneCampaignQueue,
		fetchOneSuccess: CampaignActions.fetchOneCampaignSuccess,
		fetchOneFailure: CampaignActions.fetchOneCampaignFailure,
		fetchSuccess: CampaignActions.fetchCampaignSuccess,
		fetchFailure: CampaignActions.fetchCampaignFailure,
		saveSuccess: CampaignActions.saveCampaignSuccess,
		saveFailure: CampaignActions.saveCampaignFailure,
		saveManySuccess: CampaignActions.saveManyCampaignsSuccess,
		saveManyFailure: CampaignActions.saveManyCampaignsFailure,
		removeSuccess: CampaignActions.removeCampaignSuccess,
		removeFailure: CampaignActions.removeCampaignFailure,
		restoreSuccess: CampaignActions.restoreCampaignSuccess,
		restoreFailure: CampaignActions.restoreCampaignFailure,
		save: CampaignActions.saveCampaign,
		saveQueue: CampaignActions.saveCampaignQueue,
		saveMany: CampaignActions.saveManyCampaigns,
		saveManyQueue: CampaignActions.saveManyCampaignsQueue,
		remove: CampaignActions.removeCampaign,
		removeQueue: CampaignActions.removeCampaignQueue,
		restore: CampaignActions.restoreCampaign,
		restoreQueue: CampaignActions.restoreCampaignQueue,
		restoreMany: CampaignActions.restoreManyCampaigns,
		removeMany: CampaignActions.removeManyCampaigns,
		delete: deleteCampaign
	},
	{
		name: 'docket',
		plural: 'dockets',
		clazz: Entities.Docket,
		table: 'DOCKET',
		fetchOneQueue: DocketActions.fetchOneDocketQueue,
		fetchOneSuccess: DocketActions.fetchOneDocketSuccess,
		fetchOneFailure: DocketActions.fetchOneDocketFailure,
		fetchSuccess: DocketActions.fetchDocketSuccess,
		fetchFailure: DocketActions.fetchDocketFailure,
		saveSuccess: DocketActions.saveDocketSuccess,
		saveFailure: DocketActions.saveDocketFailure,
		saveManySuccess: DocketActions.saveManyDocketsSuccess,
		saveManyFailure: DocketActions.saveManyDocketsFailure,
		removeSuccess: DocketActions.removeDocketSuccess,
		removeFailure: DocketActions.removeDocketFailure,
		restoreSuccess: DocketActions.restoreDocketSuccess,
		restoreFailure: DocketActions.restoreDocketFailure,
		save: DocketActions.saveDocket,
		saveQueue: DocketActions.saveDocketQueue,
		saveMany: DocketActions.saveManyDockets,
		saveManyQueue: DocketActions.saveManyDocketsQueue,
		remove: DocketActions.removeDocket,
		removeQueue: DocketActions.removeDocketQueue,
		restore: DocketActions.restoreDocket,
		restoreQueue: DocketActions.restoreDocketQueue,
		restoreMany: DocketActions.restoreManyDockets,
		removeMany: DocketActions.removeManyDockets,
		delete: deleteDocket
	},
	{
		name: 'matter',
		plural: 'matters',
		clazz: Entities.Matter,
		table: 'MATTER',
		fetchOneQueue: MatterActions.fetchOneMatterQueue,
		fetchOneSuccess: MatterActions.fetchOneMatterSuccess,
		fetchOneFailure: MatterActions.fetchOneMatterFailure,
		fetchSuccess: MatterActions.fetchMatterSuccess,
		fetchFailure: MatterActions.fetchMatterFailure,
		saveSuccess: MatterActions.saveMatterSuccess,
		saveFailure: MatterActions.saveMatterFailure,
		saveManySuccess: MatterActions.saveManyMattersSuccess,
		saveManyFailure: MatterActions.saveManyMattersFailure,
		removeSuccess: MatterActions.removeMatterSuccess,
		removeFailure: MatterActions.removeMatterFailure,
		restoreSuccess: MatterActions.restoreMatterSuccess,
		restoreFailure: MatterActions.restoreMatterFailure,
		save: MatterActions.saveMatter,
		saveQueue: MatterActions.saveMatterQueue,
		saveMany: MatterActions.saveManyMatters,
		saveManyQueue: MatterActions.saveManyMattersQueue,
		remove: MatterActions.removeMatter,
		removeQueue: MatterActions.removeMatterQueue,
		restore: MatterActions.restoreMatter,
		restoreQueue: MatterActions.restoreMatterQueue,
		restoreMany: MatterActions.restoreManyMatters,
		removeMany: MatterActions.removeManyMatters,
		delete: deleteMatter
	},
	{
		name: 'comment',
		plural: 'comments',
		clazz: Entities.Comment,
		table: 'COMMENT',
		fetchOneQueue: CommentActions.fetchOneCommentQueue,
		fetchOneSuccess: CommentActions.fetchOneCommentSuccess,
		fetchOneFailure: CommentActions.fetchOneCommentFailure,
		fetchSuccess: CommentActions.fetchCommentSuccess,
		fetchFailure: CommentActions.fetchCommentFailure,
		saveSuccess: CommentActions.saveCommentSuccess,
		saveFailure: CommentActions.saveCommentFailure,
		saveManySuccess: CommentActions.saveManyCommentsSuccess,
		saveManyFailure: CommentActions.saveManyCommentsFailure,
		removeSuccess: CommentActions.removeCommentSuccess,
		removeFailure: CommentActions.removeCommentFailure,
		restoreSuccess: CommentActions.restoreCommentSuccess,
		restoreFailure: CommentActions.restoreCommentFailure,
		save: CommentActions.saveComment,
		saveQueue: CommentActions.saveCommentQueue,
		saveMany: CommentActions.saveManyComments,
		saveManyQueue: CommentActions.saveManyCommentsQueue,
		remove: CommentActions.removeComment,
		removeQueue: CommentActions.removeCommentQueue,
		restore: CommentActions.restoreComment,
		restoreQueue: CommentActions.restoreCommentQueue,
		restoreMany: CommentActions.restoreManyComments,
		removeMany: CommentActions.removeManyComments,
		delete: deleteComment
	},
	{
		name: 'caseType',
		plural: 'caseTypes',
		clazz: Entities.CaseType,
		table: 'CASE_TYPE',
		fetchOneQueue: CaseTypeActions.fetchOneCaseTypeQueue,
		fetchOneSuccess: CaseTypeActions.fetchOneCaseTypeSuccess,
		fetchOneFailure: CaseTypeActions.fetchOneCaseTypeFailure,
		fetchSuccess: CaseTypeActions.fetchCaseTypeSuccess,
		fetchFailure: CaseTypeActions.fetchCaseTypeFailure,
		saveSuccess: CaseTypeActions.saveCaseTypeSuccess,
		saveFailure: CaseTypeActions.saveCaseTypeFailure,
		saveManySuccess: CaseTypeActions.saveManyCaseTypesSuccess,
		saveManyFailure: CaseTypeActions.saveManyCaseTypesFailure,
		removeSuccess: CaseTypeActions.removeCaseTypeSuccess,
		removeFailure: CaseTypeActions.removeCaseTypeFailure,
		restoreSuccess: CaseTypeActions.restoreCaseTypeSuccess,
		restoreFailure: CaseTypeActions.restoreCaseTypeFailure,
		save: CaseTypeActions.saveCaseType,
		saveQueue: CaseTypeActions.saveCaseTypeQueue,
		saveMany: CaseTypeActions.saveManyCaseTypes,
		saveManyQueue: CaseTypeActions.saveManyCaseTypesQueue,
		remove: CaseTypeActions.removeCaseType,
		removeQueue: CaseTypeActions.removeCaseTypeQueue,
		restore: CaseTypeActions.restoreCaseType,
		restoreQueue: CaseTypeActions.restoreCaseTypeQueue,
		restoreMany: CaseTypeActions.restoreManyCaseTypes,
		removeMany: CaseTypeActions.removeManyCaseTypes,
		delete: deleteCaseType
	},
	{
		name: 'caseTypeStage',
		plural: 'caseTypeStages',
		clazz: Entities.CaseTypeStage,
		table: 'CASE_TYPE_STAGE',
		fetchOneQueue: CaseTypeStageActions.fetchOneCaseTypeStageQueue,
		fetchOneSuccess: CaseTypeStageActions.fetchOneCaseTypeStageSuccess,
		fetchOneFailure: CaseTypeStageActions.fetchOneCaseTypeStageFailure,
		fetchSuccess: CaseTypeStageActions.fetchCaseTypeStageSuccess,
		fetchFailure: CaseTypeStageActions.fetchCaseTypeStageFailure,
		saveSuccess: CaseTypeStageActions.saveCaseTypeStageSuccess,
		saveFailure: CaseTypeStageActions.saveCaseTypeStageFailure,
		saveManySuccess: CaseTypeStageActions.saveManyCaseTypeStagesSuccess,
		saveManyFailure: CaseTypeStageActions.saveManyCaseTypeStagesFailure,
		removeSuccess: CaseTypeStageActions.removeCaseTypeStageSuccess,
		removeFailure: CaseTypeStageActions.removeCaseTypeStageFailure,
		restoreSuccess: CaseTypeStageActions.restoreCaseTypeStageSuccess,
		restoreFailure: CaseTypeStageActions.restoreCaseTypeStageFailure,
		save: CaseTypeStageActions.saveCaseTypeStage,
		saveQueue: CaseTypeStageActions.saveCaseTypeStageQueue,
		saveMany: CaseTypeStageActions.saveManyCaseTypeStages,
		saveManyQueue: CaseTypeStageActions.saveManyCaseTypeStagesQueue,
		remove: CaseTypeStageActions.removeCaseTypeStage,
		removeQueue: CaseTypeStageActions.removeCaseTypeStageQueue,
		restore: CaseTypeStageActions.restoreCaseTypeStage,
		restoreQueue: CaseTypeStageActions.restoreCaseTypeStageQueue,
		restoreMany: CaseTypeStageActions.restoreManyCaseTypeStages,
		removeMany: CaseTypeStageActions.removeManyCaseTypeStages,
		delete: deleteCaseTypeStage
	},
	{
		name: 'deadline',
		plural: 'deadlines',
		clazz: Entities.Deadline,
		table: 'DEADLINE',
		fetchOneQueue: DeadlineActions.fetchOneDeadlineQueue,
		fetchOneSuccess: DeadlineActions.fetchOneDeadlineSuccess,
		fetchOneFailure: DeadlineActions.fetchOneDeadlineFailure,
		fetchSuccess: DeadlineActions.fetchDeadlineSuccess,
		fetchFailure: DeadlineActions.fetchDeadlineFailure,
		saveSuccess: DeadlineActions.saveDeadlineSuccess,
		saveFailure: DeadlineActions.saveDeadlineFailure,
		saveManySuccess: DeadlineActions.saveManyDeadlinesSuccess,
		saveManyFailure: DeadlineActions.saveManyDeadlinesFailure,
		removeSuccess: DeadlineActions.removeDeadlineSuccess,
		removeFailure: DeadlineActions.removeDeadlineFailure,
		restoreSuccess: DeadlineActions.restoreDeadlineSuccess,
		restoreFailure: DeadlineActions.restoreDeadlineFailure,
		save: DeadlineActions.saveDeadline,
		saveQueue: DeadlineActions.saveDeadlineQueue,
		saveMany: DeadlineActions.saveManyDeadlines,
		saveManyQueue: DeadlineActions.saveManyDeadlinesQueue,
		remove: DeadlineActions.removeDeadline,
		removeQueue: DeadlineActions.removeDeadlineQueue,
		restore: DeadlineActions.restoreDeadline,
		restoreQueue: DeadlineActions.restoreDeadlineQueue,
		restoreMany: DeadlineActions.restoreManyDeadlines,
		removeMany: DeadlineActions.removeManyDeadlines,
		delete: deleteDeadline
	},
	{
		name: 'deadlineRule',
		plural: 'deadlineRules',
		clazz: Entities.DeadlineRule,
		table: 'DEADLINE_RULE',
		fetchOneQueue: DeadlineRuleActions.fetchOneDeadlineRuleQueue,
		fetchOneSuccess: DeadlineRuleActions.fetchOneDeadlineRuleSuccess,
		fetchOneFailure: DeadlineRuleActions.fetchOneDeadlineRuleFailure,
		fetchSuccess: DeadlineRuleActions.fetchDeadlineRuleSuccess,
		fetchFailure: DeadlineRuleActions.fetchDeadlineRuleFailure,
		saveSuccess: DeadlineRuleActions.saveDeadlineRuleSuccess,
		saveFailure: DeadlineRuleActions.saveDeadlineRuleFailure,
		saveManySuccess: DeadlineRuleActions.saveManyDeadlineRulesSuccess,
		saveManyFailure: DeadlineRuleActions.saveManyDeadlineRulesFailure,
		removeSuccess: DeadlineRuleActions.removeDeadlineRuleSuccess,
		removeFailure: DeadlineRuleActions.removeDeadlineRuleFailure,
		restoreSuccess: DeadlineRuleActions.restoreDeadlineRuleSuccess,
		restoreFailure: DeadlineRuleActions.restoreDeadlineRuleFailure,
		save: DeadlineRuleActions.saveDeadlineRule,
		saveQueue: DeadlineRuleActions.saveDeadlineRuleQueue,
		saveMany: DeadlineRuleActions.saveManyDeadlineRules,
		saveManyQueue: DeadlineRuleActions.saveManyDeadlineRulesQueue,
		remove: DeadlineRuleActions.removeDeadlineRule,
		removeQueue: DeadlineRuleActions.removeDeadlineRuleQueue,
		restore: DeadlineRuleActions.restoreDeadlineRule,
		restoreQueue: DeadlineRuleActions.restoreDeadlineRuleQueue,
		restoreMany: DeadlineRuleActions.restoreManyDeadlineRules,
		removeMany: DeadlineRuleActions.removeManyDeadlineRules,
		delete: deleteDeadlineRule
	},
	{
		name: 'conflict',
		plural: 'conflicts',
		clazz: Entities.Conflict,
		table: 'CONFLICT',
		fetchOneQueue: ConflictActions.fetchOneConflictQueue,
		fetchOneSuccess: ConflictActions.fetchOneConflictSuccess,
		fetchOneFailure: ConflictActions.fetchOneConflictFailure,
		fetchSuccess: ConflictActions.fetchConflictSuccess,
		fetchFailure: ConflictActions.fetchConflictFailure,
		saveSuccess: ConflictActions.saveConflictSuccess,
		saveFailure: ConflictActions.saveConflictFailure,
		saveManySuccess: ConflictActions.saveManyConflictsSuccess,
		saveManyFailure: ConflictActions.saveManyConflictsFailure,
		removeSuccess: ConflictActions.removeConflictSuccess,
		removeFailure: ConflictActions.removeConflictFailure,
		restoreSuccess: ConflictActions.restoreConflictSuccess,
		restoreFailure: ConflictActions.restoreConflictFailure,
		save: ConflictActions.saveConflict,
		saveQueue: ConflictActions.saveConflictQueue,
		saveMany: ConflictActions.saveManyConflicts,
		saveManyQueue: ConflictActions.saveManyConflictsQueue,
		remove: ConflictActions.removeConflict,
		removeQueue: ConflictActions.removeConflictQueue,
		restore: ConflictActions.restoreConflict,
		restoreQueue: ConflictActions.restoreConflictQueue,
		restoreMany: ConflictActions.restoreManyConflicts,
		removeMany: ConflictActions.removeManyConflicts,
		delete: deleteConflict
	},
	{
		name: 'contact',
		plural: 'contacts',
		clazz: Entities.Contact,
		table: 'CONTACT',
		fetchOneQueue: ContactActions.fetchOneContactQueue,
		fetchOneSuccess: ContactActions.fetchOneContactSuccess,
		fetchOneFailure: ContactActions.fetchOneContactFailure,
		fetchSuccess: ContactActions.fetchContactSuccess,
		fetchFailure: ContactActions.fetchContactFailure,
		saveSuccess: ContactActions.saveContactSuccess,
		saveFailure: ContactActions.saveContactFailure,
		saveManySuccess: ContactActions.saveManyContactsSuccess,
		saveManyFailure: ContactActions.saveManyContactsFailure,
		removeSuccess: ContactActions.removeContactSuccess,
		removeFailure: ContactActions.removeContactFailure,
		restoreSuccess: ContactActions.restoreContactSuccess,
		restoreFailure: ContactActions.restoreContactFailure,
		save: ContactActions.saveContact,
		saveQueue: ContactActions.saveContactQueue,
		saveMany: ContactActions.saveManyContacts,
		saveManyQueue: ContactActions.saveManyContactsQueue,
		remove: ContactActions.removeContact,
		removeQueue: ContactActions.removeContactQueue,
		restore: ContactActions.restoreContact,
		restoreQueue: ContactActions.restoreContactQueue,
		restoreMany: ContactActions.restoreManyContacts,
		removeMany: ContactActions.removeManyContacts,
		delete: deleteContact
	},
	{
		name: 'court',
		plural: 'courts',
		clazz: Entities.Court,
		table: 'COURT',
		fetchOneQueue: CourtActions.fetchOneCourtQueue,
		fetchOneSuccess: CourtActions.fetchOneCourtSuccess,
		fetchOneFailure: CourtActions.fetchOneCourtFailure,
		fetchSuccess: CourtActions.fetchCourtSuccess,
		fetchFailure: CourtActions.fetchCourtFailure,
		saveSuccess: CourtActions.saveCourtSuccess,
		saveFailure: CourtActions.saveCourtFailure,
		saveManySuccess: CourtActions.saveManyCourtsSuccess,
		saveManyFailure: CourtActions.saveManyCourtsFailure,
		removeSuccess: CourtActions.removeCourtSuccess,
		removeFailure: CourtActions.removeCourtFailure,
		restoreSuccess: CourtActions.restoreCourtSuccess,
		restoreFailure: CourtActions.restoreCourtFailure,
		save: CourtActions.saveCourt,
		saveQueue: CourtActions.saveCourtQueue,
		saveMany: CourtActions.saveManyCourts,
		saveManyQueue: CourtActions.saveManyCourtsQueue,
		remove: CourtActions.removeCourt,
		removeQueue: CourtActions.removeCourtQueue,
		restore: CourtActions.restoreCourt,
		restoreQueue: CourtActions.restoreCourtQueue,
		restoreMany: CourtActions.restoreManyCourts,
		removeMany: CourtActions.removeManyCourts,
		delete: deleteCourt
	},
	{
		name: 'courtDeadlineRule',
		plural: 'courtDeadlineRules',
		clazz: Entities.CourtDeadlineRule,
		table: 'COURT_DEADLINE_RULE',
		fetchOneQueue: CourtDeadlineRuleActions.fetchOneCourtDeadlineRuleQueue,
		fetchOneSuccess: CourtDeadlineRuleActions.fetchOneCourtDeadlineRuleSuccess,
		fetchOneFailure: CourtDeadlineRuleActions.fetchOneCourtDeadlineRuleFailure,
		fetchSuccess: CourtDeadlineRuleActions.fetchCourtDeadlineRuleSuccess,
		fetchFailure: CourtDeadlineRuleActions.fetchCourtDeadlineRuleFailure,
		saveSuccess: CourtDeadlineRuleActions.saveCourtDeadlineRuleSuccess,
		saveFailure: CourtDeadlineRuleActions.saveCourtDeadlineRuleFailure,
		saveManySuccess: CourtDeadlineRuleActions.saveManyCourtDeadlineRulesSuccess,
		saveManyFailure: CourtDeadlineRuleActions.saveManyCourtDeadlineRulesFailure,
		removeSuccess: CourtDeadlineRuleActions.removeCourtDeadlineRuleSuccess,
		removeFailure: CourtDeadlineRuleActions.removeCourtDeadlineRuleFailure,
		restoreSuccess: CourtDeadlineRuleActions.restoreCourtDeadlineRuleSuccess,
		restoreFailure: CourtDeadlineRuleActions.restoreCourtDeadlineRuleFailure,
		save: CourtDeadlineRuleActions.saveCourtDeadlineRule,
		saveQueue: CourtDeadlineRuleActions.saveCourtDeadlineRuleQueue,
		saveMany: CourtDeadlineRuleActions.saveManyCourtDeadlineRules,
		saveManyQueue: CourtDeadlineRuleActions.saveManyCourtDeadlineRulesQueue,
		remove: CourtDeadlineRuleActions.removeCourtDeadlineRule,
		removeQueue: CourtDeadlineRuleActions.removeCourtDeadlineRuleQueue,
		restore: CourtDeadlineRuleActions.restoreCourtDeadlineRule,
		restoreQueue: CourtDeadlineRuleActions.restoreCourtDeadlineRuleQueue,
		restoreMany: CourtDeadlineRuleActions.restoreManyCourtDeadlineRules,
		removeMany: CourtDeadlineRuleActions.removeManyCourtDeadlineRules,
		delete: deleteCourtDeadlineRule
	},
	{
		name: 'discount',
		plural: 'discounts',
		clazz: Entities.Discount,
		table: 'DISCOUNT',
		fetchOneQueue: DiscountActions.fetchOneDiscountQueue,
		fetchOneSuccess: DiscountActions.fetchOneDiscountSuccess,
		fetchOneFailure: DiscountActions.fetchOneDiscountFailure,
		fetchSuccess: DiscountActions.fetchDiscountSuccess,
		fetchFailure: DiscountActions.fetchDiscountFailure,
		saveSuccess: DiscountActions.saveDiscountSuccess,
		saveFailure: DiscountActions.saveDiscountFailure,
		saveManySuccess: DiscountActions.saveManyDiscountsSuccess,
		saveManyFailure: DiscountActions.saveManyDiscountsFailure,
		removeSuccess: DiscountActions.removeDiscountSuccess,
		removeFailure: DiscountActions.removeDiscountFailure,
		restoreSuccess: DiscountActions.restoreDiscountSuccess,
		restoreFailure: DiscountActions.restoreDiscountFailure,
		save: DiscountActions.saveDiscount,
		saveQueue: DiscountActions.saveDiscountQueue,
		saveMany: DiscountActions.saveManyDiscounts,
		saveManyQueue: DiscountActions.saveManyDiscountsQueue,
		remove: DiscountActions.removeDiscount,
		removeQueue: DiscountActions.removeDiscountQueue,
		restore: DiscountActions.restoreDiscount,
		restoreQueue: DiscountActions.restoreDiscountQueue,
		restoreMany: DiscountActions.restoreManyDiscounts,
		removeMany: DiscountActions.removeManyDiscounts,
		delete: deleteDiscount
	},
	{
		name: 'entityTimestamp',
		plural: 'entityTimestamps',
		clazz: Entities.EntityTimestamp,
		table: 'ENTITY_TIMESTAMP',
		fetchOneQueue: EntityTimestampActions.fetchOneEntityTimestampQueue,
		fetchOneSuccess: EntityTimestampActions.fetchOneEntityTimestampSuccess,
		fetchOneFailure: EntityTimestampActions.fetchOneEntityTimestampFailure,
		fetchSuccess: EntityTimestampActions.fetchEntityTimestampSuccess,
		fetchFailure: EntityTimestampActions.fetchEntityTimestampFailure,
		saveSuccess: EntityTimestampActions.saveEntityTimestampSuccess,
		saveFailure: EntityTimestampActions.saveEntityTimestampFailure,
		saveManySuccess: EntityTimestampActions.saveManyEntityTimestampsSuccess,
		saveManyFailure: EntityTimestampActions.saveManyEntityTimestampsFailure,
		removeSuccess: EntityTimestampActions.removeEntityTimestampSuccess,
		removeFailure: EntityTimestampActions.removeEntityTimestampFailure,
		restoreSuccess: EntityTimestampActions.restoreEntityTimestampSuccess,
		restoreFailure: EntityTimestampActions.restoreEntityTimestampFailure,
		save: EntityTimestampActions.saveEntityTimestamp,
		saveQueue: EntityTimestampActions.saveEntityTimestampQueue,
		saveMany: EntityTimestampActions.saveManyEntityTimestamps,
		saveManyQueue: EntityTimestampActions.saveManyEntityTimestampsQueue,
		remove: EntityTimestampActions.removeEntityTimestamp,
		removeQueue: EntityTimestampActions.removeEntityTimestampQueue,
		restore: EntityTimestampActions.restoreEntityTimestamp,
		restoreQueue: EntityTimestampActions.restoreEntityTimestampQueue,
		restoreMany: EntityTimestampActions.restoreManyEntityTimestamps,
		removeMany: EntityTimestampActions.removeManyEntityTimestamps,
		delete: deleteEntityTimestamp
	},
	{
		name: 'document',
		plural: 'documents',
		clazz: Entities.Document,
		table: 'DOCUMENT',
		fetchOneQueue: DocumentActions.fetchOneDocumentQueue,
		fetchOneSuccess: DocumentActions.fetchOneDocumentSuccess,
		fetchOneFailure: DocumentActions.fetchOneDocumentFailure,
		fetchSuccess: DocumentActions.fetchDocumentSuccess,
		fetchFailure: DocumentActions.fetchDocumentFailure,
		saveSuccess: DocumentActions.saveDocumentSuccess,
		saveFailure: DocumentActions.saveDocumentFailure,
		saveManySuccess: DocumentActions.saveManyDocumentsSuccess,
		saveManyFailure: DocumentActions.saveManyDocumentsFailure,
		removeSuccess: DocumentActions.removeDocumentSuccess,
		removeFailure: DocumentActions.removeDocumentFailure,
		restoreSuccess: DocumentActions.restoreDocumentSuccess,
		restoreFailure: DocumentActions.restoreDocumentFailure,
		save: DocumentActions.saveDocument,
		saveQueue: DocumentActions.saveDocumentQueue,
		saveMany: DocumentActions.saveManyDocuments,
		saveManyQueue: DocumentActions.saveManyDocumentsQueue,
		remove: DocumentActions.removeDocument,
		removeQueue: DocumentActions.removeDocumentQueue,
		restore: DocumentActions.restoreDocument,
		restoreQueue: DocumentActions.restoreDocumentQueue,
		restoreMany: DocumentActions.restoreManyDocuments,
		removeMany: DocumentActions.removeManyDocuments,
		delete: deleteDocument
	},
	{
		name: 'expense',
		plural: 'expenses',
		clazz: Entities.Expense,
		table: 'EXPENSE',
		fetchOneQueue: ExpenseActions.fetchOneExpenseQueue,
		fetchOneSuccess: ExpenseActions.fetchOneExpenseSuccess,
		fetchOneFailure: ExpenseActions.fetchOneExpenseFailure,
		fetchSuccess: ExpenseActions.fetchExpenseSuccess,
		fetchFailure: ExpenseActions.fetchExpenseFailure,
		saveSuccess: ExpenseActions.saveExpenseSuccess,
		saveFailure: ExpenseActions.saveExpenseFailure,
		saveManySuccess: ExpenseActions.saveManyExpensesSuccess,
		saveManyFailure: ExpenseActions.saveManyExpensesFailure,
		removeSuccess: ExpenseActions.removeExpenseSuccess,
		removeFailure: ExpenseActions.removeExpenseFailure,
		restoreSuccess: ExpenseActions.restoreExpenseSuccess,
		restoreFailure: ExpenseActions.restoreExpenseFailure,
		save: ExpenseActions.saveExpense,
		saveQueue: ExpenseActions.saveExpenseQueue,
		saveMany: ExpenseActions.saveManyExpenses,
		saveManyQueue: ExpenseActions.saveManyExpensesQueue,
		remove: ExpenseActions.removeExpense,
		removeQueue: ExpenseActions.removeExpenseQueue,
		restore: ExpenseActions.restoreExpense,
		restoreQueue: ExpenseActions.restoreExpenseQueue,
		restoreMany: ExpenseActions.restoreManyExpenses,
		removeMany: ExpenseActions.removeManyExpenses,
		delete: deleteExpense
	},
	{
		name: 'event',
		plural: 'events',
		clazz: Entities.Event,
		table: 'EVENT',
		fetchOneQueue: EventActions.fetchOneEventQueue,
		fetchOneSuccess: EventActions.fetchOneEventSuccess,
		fetchOneFailure: EventActions.fetchOneEventFailure,
		fetchSuccess: EventActions.fetchEventSuccess,
		fetchFailure: EventActions.fetchEventFailure,
		saveSuccess: EventActions.saveEventSuccess,
		saveFailure: EventActions.saveEventFailure,
		saveManySuccess: EventActions.saveManyEventsSuccess,
		saveManyFailure: EventActions.saveManyEventsFailure,
		removeSuccess: EventActions.removeEventSuccess,
		removeFailure: EventActions.removeEventFailure,
		restoreSuccess: EventActions.restoreEventSuccess,
		restoreFailure: EventActions.restoreEventFailure,
		save: EventActions.saveEvent,
		saveQueue: EventActions.saveEventQueue,
		saveMany: EventActions.saveManyEvents,
		saveManyQueue: EventActions.saveManyEventsQueue,
		remove: EventActions.removeEvent,
		removeQueue: EventActions.removeEventQueue,
		restore: EventActions.restoreEvent,
		restoreQueue: EventActions.restoreEventQueue,
		restoreMany: EventActions.restoreManyEvents,
		removeMany: EventActions.removeManyEvents,
		delete: deleteEvent
	},
	{
		name: 'firm',
		plural: 'firms',
		clazz: Entities.Firm,
		table: 'FIRM',
		fetchOneQueue: FirmActions.fetchOneFirmQueue,
		fetchOneSuccess: FirmActions.fetchOneFirmSuccess,
		fetchOneFailure: FirmActions.fetchOneFirmFailure,
		fetchSuccess: FirmActions.fetchFirmSuccess,
		fetchFailure: FirmActions.fetchFirmFailure,
		saveSuccess: FirmActions.saveFirmSuccess,
		saveFailure: FirmActions.saveFirmFailure,
		saveManySuccess: FirmActions.saveManyFirmsSuccess,
		saveManyFailure: FirmActions.saveManyFirmsFailure,
		removeSuccess: FirmActions.removeFirmSuccess,
		removeFailure: FirmActions.removeFirmFailure,
		restoreSuccess: FirmActions.restoreFirmSuccess,
		restoreFailure: FirmActions.restoreFirmFailure,
		save: FirmActions.saveFirm,
		saveQueue: FirmActions.saveFirmQueue,
		saveMany: FirmActions.saveManyFirms,
		saveManyQueue: FirmActions.saveManyFirmsQueue,
		remove: FirmActions.removeFirm,
		removeQueue: FirmActions.removeFirmQueue,
		restore: FirmActions.restoreFirm,
		restoreQueue: FirmActions.restoreFirmQueue,
		restoreMany: FirmActions.restoreManyFirms,
		removeMany: FirmActions.removeManyFirms,
		delete: deleteFirm
	},
	{
		name: 'flatFee',
		plural: 'flatFees',
		clazz: Entities.FlatFee,
		table: 'FLAT_FEE',
		fetchOneQueue: FlatFeeActions.fetchOneFlatFeeQueue,
		fetchOneSuccess: FlatFeeActions.fetchOneFlatFeeSuccess,
		fetchOneFailure: FlatFeeActions.fetchOneFlatFeeFailure,
		fetchSuccess: FlatFeeActions.fetchFlatFeeSuccess,
		fetchFailure: FlatFeeActions.fetchFlatFeeFailure,
		saveSuccess: FlatFeeActions.saveFlatFeeSuccess,
		saveFailure: FlatFeeActions.saveFlatFeeFailure,
		saveManySuccess: FlatFeeActions.saveManyFlatFeesSuccess,
		saveManyFailure: FlatFeeActions.saveManyFlatFeesFailure,
		removeSuccess: FlatFeeActions.removeFlatFeeSuccess,
		removeFailure: FlatFeeActions.removeFlatFeeFailure,
		restoreSuccess: FlatFeeActions.restoreFlatFeeSuccess,
		restoreFailure: FlatFeeActions.restoreFlatFeeFailure,
		save: FlatFeeActions.saveFlatFee,
		saveQueue: FlatFeeActions.saveFlatFeeQueue,
		saveMany: FlatFeeActions.saveManyFlatFees,
		saveManyQueue: FlatFeeActions.saveManyFlatFeesQueue,
		remove: FlatFeeActions.removeFlatFee,
		removeQueue: FlatFeeActions.removeFlatFeeQueue,
		restore: FlatFeeActions.restoreFlatFee,
		restoreQueue: FlatFeeActions.restoreFlatFeeQueue,
		restoreMany: FlatFeeActions.restoreManyFlatFees,
		removeMany: FlatFeeActions.removeManyFlatFees,
		delete: deleteFlatFee
	},
	{
		name: 'flatFeeMilestone',
		plural: 'flatFeeMilestones',
		clazz: Entities.FlatFeeMilestone,
		table: 'FLAT_FEE_MILESTONE',
		fetchOneQueue: FlatFeeMilestoneActions.fetchOneFlatFeeMilestoneQueue,
		fetchOneSuccess: FlatFeeMilestoneActions.fetchOneFlatFeeMilestoneSuccess,
		fetchOneFailure: FlatFeeMilestoneActions.fetchOneFlatFeeMilestoneFailure,
		fetchSuccess: FlatFeeMilestoneActions.fetchFlatFeeMilestoneSuccess,
		fetchFailure: FlatFeeMilestoneActions.fetchFlatFeeMilestoneFailure,
		saveSuccess: FlatFeeMilestoneActions.saveFlatFeeMilestoneSuccess,
		saveFailure: FlatFeeMilestoneActions.saveFlatFeeMilestoneFailure,
		saveManySuccess: FlatFeeMilestoneActions.saveManyFlatFeeMilestonesSuccess,
		saveManyFailure: FlatFeeMilestoneActions.saveManyFlatFeeMilestonesFailure,
		removeSuccess: FlatFeeMilestoneActions.removeFlatFeeMilestoneSuccess,
		removeFailure: FlatFeeMilestoneActions.removeFlatFeeMilestoneFailure,
		restoreSuccess: FlatFeeMilestoneActions.restoreFlatFeeMilestoneSuccess,
		restoreFailure: FlatFeeMilestoneActions.restoreFlatFeeMilestoneFailure,
		save: FlatFeeMilestoneActions.saveFlatFeeMilestone,
		saveQueue: FlatFeeMilestoneActions.saveFlatFeeMilestoneQueue,
		saveMany: FlatFeeMilestoneActions.saveManyFlatFeeMilestones,
		saveManyQueue: FlatFeeMilestoneActions.saveManyFlatFeeMilestonesQueue,
		remove: FlatFeeMilestoneActions.removeFlatFeeMilestone,
		removeQueue: FlatFeeMilestoneActions.removeFlatFeeMilestoneQueue,
		restore: FlatFeeMilestoneActions.restoreFlatFeeMilestone,
		restoreQueue: FlatFeeMilestoneActions.restoreFlatFeeMilestoneQueue,
		restoreMany: FlatFeeMilestoneActions.restoreManyFlatFeeMilestones,
		removeMany: FlatFeeMilestoneActions.removeManyFlatFeeMilestones,
		delete: deleteFlatFeeMilestone
	},
	{
		name: 'group',
		plural: 'groups',
		clazz: Entities.Group,
		table: 'GROUPS',
		fetchOneQueue: GroupActions.fetchOneGroupQueue,
		fetchOneSuccess: GroupActions.fetchOneGroupSuccess,
		fetchOneFailure: GroupActions.fetchOneGroupFailure,
		fetchSuccess: GroupActions.fetchGroupSuccess,
		fetchFailure: GroupActions.fetchGroupFailure,
		saveSuccess: GroupActions.saveGroupSuccess,
		saveFailure: GroupActions.saveGroupFailure,
		saveManySuccess: GroupActions.saveManyGroupsSuccess,
		saveManyFailure: GroupActions.saveManyGroupsFailure,
		removeSuccess: GroupActions.removeGroupSuccess,
		removeFailure: GroupActions.removeGroupFailure,
		restoreSuccess: GroupActions.restoreGroupSuccess,
		restoreFailure: GroupActions.restoreGroupFailure,
		save: GroupActions.saveGroup,
		saveQueue: GroupActions.saveGroupQueue,
		saveMany: GroupActions.saveManyGroups,
		saveManyQueue: GroupActions.saveManyGroupsQueue,
		remove: GroupActions.removeGroup,
		removeQueue: GroupActions.removeGroupQueue,
		restore: GroupActions.restoreGroup,
		restoreQueue: GroupActions.restoreGroupQueue,
		restoreMany: GroupActions.restoreManyGroups,
		removeMany: GroupActions.removeManyGroups,
		delete: deleteGroup
	},
	{
		name: 'holidayCalendar',
		plural: 'holidayCalendars',
		clazz: Entities.HolidayCalendar,
		table: 'HOLIDAY_CALENDAR',
		fetchOneQueue: HolidayCalendarActions.fetchOneHolidayCalendarQueue,
		fetchOneSuccess: HolidayCalendarActions.fetchOneHolidayCalendarSuccess,
		fetchOneFailure: HolidayCalendarActions.fetchOneHolidayCalendarFailure,
		fetchSuccess: HolidayCalendarActions.fetchHolidayCalendarSuccess,
		fetchFailure: HolidayCalendarActions.fetchHolidayCalendarFailure,
		saveSuccess: HolidayCalendarActions.saveHolidayCalendarSuccess,
		saveFailure: HolidayCalendarActions.saveHolidayCalendarFailure,
		saveManySuccess: HolidayCalendarActions.saveManyHolidayCalendarsSuccess,
		saveManyFailure: HolidayCalendarActions.saveManyHolidayCalendarsFailure,
		removeSuccess: HolidayCalendarActions.removeHolidayCalendarSuccess,
		removeFailure: HolidayCalendarActions.removeHolidayCalendarFailure,
		restoreSuccess: HolidayCalendarActions.restoreHolidayCalendarSuccess,
		restoreFailure: HolidayCalendarActions.restoreHolidayCalendarFailure,
		save: HolidayCalendarActions.saveHolidayCalendar,
		saveQueue: HolidayCalendarActions.saveHolidayCalendarQueue,
		saveMany: HolidayCalendarActions.saveManyHolidayCalendars,
		saveManyQueue: HolidayCalendarActions.saveManyHolidayCalendarsQueue,
		remove: HolidayCalendarActions.removeHolidayCalendar,
		removeQueue: HolidayCalendarActions.removeHolidayCalendarQueue,
		restore: HolidayCalendarActions.restoreHolidayCalendar,
		restoreQueue: HolidayCalendarActions.restoreHolidayCalendarQueue,
		restoreMany: HolidayCalendarActions.restoreManyHolidayCalendars,
		removeMany: HolidayCalendarActions.removeManyHolidayCalendars,
		delete: deleteHolidayCalendar
	},
	{
		name: 'identification',
		plural: 'identifications',
		clazz: Entities.Identification,
		table: 'IDENTIFICATION',
		fetchOneQueue: IdentificationActions.fetchOneIdentificationQueue,
		fetchOneSuccess: IdentificationActions.fetchOneIdentificationSuccess,
		fetchOneFailure: IdentificationActions.fetchOneIdentificationFailure,
		fetchSuccess: IdentificationActions.fetchIdentificationSuccess,
		fetchFailure: IdentificationActions.fetchIdentificationFailure,
		saveSuccess: IdentificationActions.saveIdentificationSuccess,
		saveFailure: IdentificationActions.saveIdentificationFailure,
		saveManySuccess: IdentificationActions.saveManyIdentificationsSuccess,
		saveManyFailure: IdentificationActions.saveManyIdentificationsFailure,
		removeSuccess: IdentificationActions.removeIdentificationSuccess,
		removeFailure: IdentificationActions.removeIdentificationFailure,
		restoreSuccess: IdentificationActions.restoreIdentificationSuccess,
		restoreFailure: IdentificationActions.restoreIdentificationFailure,
		save: IdentificationActions.saveIdentification,
		saveQueue: IdentificationActions.saveIdentificationQueue,
		saveMany: IdentificationActions.saveManyIdentifications,
		saveManyQueue: IdentificationActions.saveManyIdentificationsQueue,
		remove: IdentificationActions.removeIdentification,
		removeQueue: IdentificationActions.removeIdentificationQueue,
		restore: IdentificationActions.restoreIdentification,
		restoreQueue: IdentificationActions.restoreIdentificationQueue,
		restoreMany: IdentificationActions.restoreManyIdentifications,
		removeMany: IdentificationActions.removeManyIdentifications,
		delete: deleteIdentification
	},
	{
		name: 'importExport',
		plural: 'importExports',
		clazz: Entities.ImportExport,
		table: 'IMPORT_EXPORT',
		fetchOneQueue: ImportExportActions.fetchOneImportExportQueue,
		fetchOneSuccess: ImportExportActions.fetchOneImportExportSuccess,
		fetchOneFailure: ImportExportActions.fetchOneImportExportFailure,
		fetchSuccess: ImportExportActions.fetchImportExportSuccess,
		fetchFailure: ImportExportActions.fetchImportExportFailure,
		saveSuccess: ImportExportActions.saveImportExportSuccess,
		saveFailure: ImportExportActions.saveImportExportFailure,
		saveManySuccess: ImportExportActions.saveManyImportExportsSuccess,
		saveManyFailure: ImportExportActions.saveManyImportExportsFailure,
		removeSuccess: ImportExportActions.removeImportExportSuccess,
		removeFailure: ImportExportActions.removeImportExportFailure,
		restoreSuccess: ImportExportActions.restoreImportExportSuccess,
		restoreFailure: ImportExportActions.restoreImportExportFailure,
		save: ImportExportActions.saveImportExport,
		saveQueue: ImportExportActions.saveImportExportQueue,
		saveMany: ImportExportActions.saveManyImportExports,
		saveManyQueue: ImportExportActions.saveManyImportExportsQueue,
		remove: ImportExportActions.removeImportExport,
		removeQueue: ImportExportActions.removeImportExportQueue,
		restore: ImportExportActions.restoreImportExport,
		restoreQueue: ImportExportActions.restoreImportExportQueue,
		restoreMany: ImportExportActions.restoreManyImportExports,
		removeMany: ImportExportActions.removeManyImportExports,
		delete: deleteImportExport
	},
	{
		name: 'importSource',
		plural: 'importSources',
		clazz: Entities.ImportSource,
		table: 'IMPORT_SOURCE',
		fetchOneQueue: ImportSourceActions.fetchOneImportSourceQueue,
		fetchOneSuccess: ImportSourceActions.fetchOneImportSourceSuccess,
		fetchOneFailure: ImportSourceActions.fetchOneImportSourceFailure,
		fetchSuccess: ImportSourceActions.fetchImportSourceSuccess,
		fetchFailure: ImportSourceActions.fetchImportSourceFailure,
		saveSuccess: ImportSourceActions.saveImportSourceSuccess,
		saveFailure: ImportSourceActions.saveImportSourceFailure,
		saveManySuccess: ImportSourceActions.saveManyImportSourcesSuccess,
		saveManyFailure: ImportSourceActions.saveManyImportSourcesFailure,
		removeSuccess: ImportSourceActions.removeImportSourceSuccess,
		removeFailure: ImportSourceActions.removeImportSourceFailure,
		restoreSuccess: ImportSourceActions.restoreImportSourceSuccess,
		restoreFailure: ImportSourceActions.restoreImportSourceFailure,
		save: ImportSourceActions.saveImportSource,
		saveQueue: ImportSourceActions.saveImportSourceQueue,
		saveMany: ImportSourceActions.saveManyImportSources,
		saveManyQueue: ImportSourceActions.saveManyImportSourcesQueue,
		remove: ImportSourceActions.removeImportSource,
		removeQueue: ImportSourceActions.removeImportSourceQueue,
		restore: ImportSourceActions.restoreImportSource,
		restoreQueue: ImportSourceActions.restoreImportSourceQueue,
		restoreMany: ImportSourceActions.restoreManyImportSources,
		removeMany: ImportSourceActions.removeManyImportSources,
		delete: deleteImportSource
	},
	{
		name: 'invoice',
		plural: 'invoices',
		clazz: Entities.Invoice,
		table: 'INVOICE',
		fetchOneQueue: InvoiceActions.fetchOneInvoiceQueue,
		fetchOneSuccess: InvoiceActions.fetchOneInvoiceSuccess,
		fetchOneFailure: InvoiceActions.fetchOneInvoiceFailure,
		fetchSuccess: InvoiceActions.fetchInvoiceSuccess,
		fetchFailure: InvoiceActions.fetchInvoiceFailure,
		saveSuccess: InvoiceActions.saveInvoiceSuccess,
		saveFailure: InvoiceActions.saveInvoiceFailure,
		saveManySuccess: InvoiceActions.saveManyInvoicesSuccess,
		saveManyFailure: InvoiceActions.saveManyInvoicesFailure,
		removeSuccess: InvoiceActions.removeInvoiceSuccess,
		removeFailure: InvoiceActions.removeInvoiceFailure,
		restoreSuccess: InvoiceActions.restoreInvoiceSuccess,
		restoreFailure: InvoiceActions.restoreInvoiceFailure,
		save: InvoiceActions.saveInvoice,
		saveQueue: InvoiceActions.saveInvoiceQueue,
		saveMany: InvoiceActions.saveManyInvoices,
		saveManyQueue: InvoiceActions.saveManyInvoicesQueue,
		remove: InvoiceActions.removeInvoice,
		removeQueue: InvoiceActions.removeInvoiceQueue,
		restore: InvoiceActions.restoreInvoice,
		restoreQueue: InvoiceActions.restoreInvoiceQueue,
		restoreMany: InvoiceActions.restoreManyInvoices,
		removeMany: InvoiceActions.removeManyInvoices,
		delete: deleteInvoice
	},
	{
		name: 'invoiceBatch',
		plural: 'invoiceBatches',
		clazz: Entities.InvoiceBatch,
		table: 'INVOICE_BATCH',
		fetchOneQueue: InvoiceBatchActions.fetchOneInvoiceBatchQueue,
		fetchOneSuccess: InvoiceBatchActions.fetchOneInvoiceBatchSuccess,
		fetchOneFailure: InvoiceBatchActions.fetchOneInvoiceBatchFailure,
		fetchSuccess: InvoiceBatchActions.fetchInvoiceBatchSuccess,
		fetchFailure: InvoiceBatchActions.fetchInvoiceBatchFailure,
		saveSuccess: InvoiceBatchActions.saveInvoiceBatchSuccess,
		saveFailure: InvoiceBatchActions.saveInvoiceBatchFailure,
		saveManySuccess: InvoiceBatchActions.saveManyInvoiceBatchesSuccess,
		saveManyFailure: InvoiceBatchActions.saveManyInvoiceBatchesFailure,
		removeSuccess: InvoiceBatchActions.removeInvoiceBatchSuccess,
		removeFailure: InvoiceBatchActions.removeInvoiceBatchFailure,
		restoreSuccess: InvoiceBatchActions.restoreInvoiceBatchSuccess,
		restoreFailure: InvoiceBatchActions.restoreInvoiceBatchFailure,
		save: InvoiceBatchActions.saveInvoiceBatch,
		saveQueue: InvoiceBatchActions.saveInvoiceBatchQueue,
		saveMany: InvoiceBatchActions.saveManyInvoiceBatches,
		saveManyQueue: InvoiceBatchActions.saveManyInvoiceBatchesQueue,
		remove: InvoiceBatchActions.removeInvoiceBatch,
		removeQueue: InvoiceBatchActions.removeInvoiceBatchQueue,
		restore: InvoiceBatchActions.restoreInvoiceBatch,
		restoreQueue: InvoiceBatchActions.restoreInvoiceBatchQueue,
		restoreMany: InvoiceBatchActions.restoreManyInvoiceBatches,
		removeMany: InvoiceBatchActions.removeManyInvoiceBatches,
		delete: deleteInvoiceBatch
	},
	{
		name: 'invoiceBatchItem',
		plural: 'invoiceBatchItems',
		clazz: Entities.InvoiceBatchItem,
		table: 'INVOICE_BATCH_ITEM',
		fetchOneQueue: InvoiceBatchItemActions.fetchOneInvoiceBatchItemQueue,
		fetchOneSuccess: InvoiceBatchItemActions.fetchOneInvoiceBatchItemSuccess,
		fetchOneFailure: InvoiceBatchItemActions.fetchOneInvoiceBatchItemFailure,
		fetchSuccess: InvoiceBatchItemActions.fetchInvoiceBatchItemSuccess,
		fetchFailure: InvoiceBatchItemActions.fetchInvoiceBatchItemFailure,
		saveSuccess: InvoiceBatchItemActions.saveInvoiceBatchItemSuccess,
		saveFailure: InvoiceBatchItemActions.saveInvoiceBatchItemFailure,
		saveManySuccess: InvoiceBatchItemActions.saveManyInvoiceBatchItemsSuccess,
		saveManyFailure: InvoiceBatchItemActions.saveManyInvoiceBatchItemsFailure,
		removeSuccess: InvoiceBatchItemActions.removeInvoiceBatchItemSuccess,
		removeFailure: InvoiceBatchItemActions.removeInvoiceBatchItemFailure,
		restoreSuccess: InvoiceBatchItemActions.restoreInvoiceBatchItemSuccess,
		restoreFailure: InvoiceBatchItemActions.restoreInvoiceBatchItemFailure,
		save: InvoiceBatchItemActions.saveInvoiceBatchItem,
		saveQueue: InvoiceBatchItemActions.saveInvoiceBatchItemQueue,
		saveMany: InvoiceBatchItemActions.saveManyInvoiceBatchItems,
		saveManyQueue: InvoiceBatchItemActions.saveManyInvoiceBatchItemsQueue,
		remove: InvoiceBatchItemActions.removeInvoiceBatchItem,
		removeQueue: InvoiceBatchItemActions.removeInvoiceBatchItemQueue,
		restore: InvoiceBatchItemActions.restoreInvoiceBatchItem,
		restoreQueue: InvoiceBatchItemActions.restoreInvoiceBatchItemQueue,
		restoreMany: InvoiceBatchItemActions.restoreManyInvoiceBatchItems,
		removeMany: InvoiceBatchItemActions.removeManyInvoiceBatchItems,
		delete: deleteInvoiceBatchItem
	},
	{
		name: 'lead',
		plural: 'leads',
		clazz: Entities.Lead,
		table: 'LEAD',
		fetchOneQueue: LeadActions.fetchOneLeadQueue,
		fetchOneSuccess: LeadActions.fetchOneLeadSuccess,
		fetchOneFailure: LeadActions.fetchOneLeadFailure,
		fetchSuccess: LeadActions.fetchLeadSuccess,
		fetchFailure: LeadActions.fetchLeadFailure,
		saveSuccess: LeadActions.saveLeadSuccess,
		saveFailure: LeadActions.saveLeadFailure,
		saveManySuccess: LeadActions.saveManyLeadsSuccess,
		saveManyFailure: LeadActions.saveManyLeadsFailure,
		removeSuccess: LeadActions.removeLeadSuccess,
		removeFailure: LeadActions.removeLeadFailure,
		restoreSuccess: LeadActions.restoreLeadSuccess,
		restoreFailure: LeadActions.restoreLeadFailure,
		save: LeadActions.saveLead,
		saveQueue: LeadActions.saveLeadQueue,
		saveMany: LeadActions.saveManyLeads,
		saveManyQueue: LeadActions.saveManyLeadsQueue,
		remove: LeadActions.removeLead,
		removeQueue: LeadActions.removeLeadQueue,
		restore: LeadActions.restoreLead,
		restoreQueue: LeadActions.restoreLeadQueue,
		restoreMany: LeadActions.restoreManyLeads,
		removeMany: LeadActions.removeManyLeads,
		delete: deleteLead
	},
	{
		name: 'lookup',
		plural: 'lookups',
		clazz: Entities.Lookup,
		table: 'LOOKUP',
		fetchOneQueue: LookupActions.fetchOneLookupQueue,
		fetchOneSuccess: LookupActions.fetchOneLookupSuccess,
		fetchOneFailure: LookupActions.fetchOneLookupFailure,
		fetchSuccess: LookupActions.fetchLookupSuccess,
		fetchFailure: LookupActions.fetchLookupFailure,
		saveSuccess: LookupActions.saveLookupSuccess,
		saveFailure: LookupActions.saveLookupFailure,
		saveManySuccess: LookupActions.saveManyLookupsSuccess,
		saveManyFailure: LookupActions.saveManyLookupsFailure,
		removeSuccess: LookupActions.removeLookupSuccess,
		removeFailure: LookupActions.removeLookupFailure,
		restoreSuccess: LookupActions.restoreLookupSuccess,
		restoreFailure: LookupActions.restoreLookupFailure,
		save: LookupActions.saveLookup,
		saveQueue: LookupActions.saveLookupQueue,
		saveMany: LookupActions.saveManyLookups,
		saveManyQueue: LookupActions.saveManyLookupsQueue,
		remove: LookupActions.removeLookup,
		removeQueue: LookupActions.removeLookupQueue,
		restore: LookupActions.restoreLookup,
		restoreQueue: LookupActions.restoreLookupQueue,
		restoreMany: LookupActions.restoreManyLookups,
		removeMany: LookupActions.removeManyLookups,
		delete: deleteLookup
	},
	{
		name: 'matterStage',
		plural: 'matterStages',
		clazz: Entities.MatterStage,
		table: 'MATTER_STAGE',
		fetchOneQueue: MatterStageActions.fetchOneMatterStageQueue,
		fetchOneSuccess: MatterStageActions.fetchOneMatterStageSuccess,
		fetchOneFailure: MatterStageActions.fetchOneMatterStageFailure,
		fetchSuccess: MatterStageActions.fetchMatterStageSuccess,
		fetchFailure: MatterStageActions.fetchMatterStageFailure,
		saveSuccess: MatterStageActions.saveMatterStageSuccess,
		saveFailure: MatterStageActions.saveMatterStageFailure,
		saveManySuccess: MatterStageActions.saveManyMatterStagesSuccess,
		saveManyFailure: MatterStageActions.saveManyMatterStagesFailure,
		removeSuccess: MatterStageActions.removeMatterStageSuccess,
		removeFailure: MatterStageActions.removeMatterStageFailure,
		restoreSuccess: MatterStageActions.restoreMatterStageSuccess,
		restoreFailure: MatterStageActions.restoreMatterStageFailure,
		save: MatterStageActions.saveMatterStage,
		saveQueue: MatterStageActions.saveMatterStageQueue,
		saveMany: MatterStageActions.saveManyMatterStages,
		saveManyQueue: MatterStageActions.saveManyMatterStagesQueue,
		remove: MatterStageActions.removeMatterStage,
		removeQueue: MatterStageActions.removeMatterStageQueue,
		restore: MatterStageActions.restoreMatterStage,
		restoreQueue: MatterStageActions.restoreMatterStageQueue,
		restoreMany: MatterStageActions.restoreManyMatterStages,
		removeMany: MatterStageActions.removeManyMatterStages,
		delete: deleteMatterStage
	},
	{
		name: 'milestone',
		plural: 'milestones',
		clazz: Entities.Milestone,
		table: 'MILESTONE',
		fetchOneQueue: MilestoneActions.fetchOneMilestoneQueue,
		fetchOneSuccess: MilestoneActions.fetchOneMilestoneSuccess,
		fetchOneFailure: MilestoneActions.fetchOneMilestoneFailure,
		fetchSuccess: MilestoneActions.fetchMilestoneSuccess,
		fetchFailure: MilestoneActions.fetchMilestoneFailure,
		saveSuccess: MilestoneActions.saveMilestoneSuccess,
		saveFailure: MilestoneActions.saveMilestoneFailure,
		saveManySuccess: MilestoneActions.saveManyMilestonesSuccess,
		saveManyFailure: MilestoneActions.saveManyMilestonesFailure,
		removeSuccess: MilestoneActions.removeMilestoneSuccess,
		removeFailure: MilestoneActions.removeMilestoneFailure,
		restoreSuccess: MilestoneActions.restoreMilestoneSuccess,
		restoreFailure: MilestoneActions.restoreMilestoneFailure,
		save: MilestoneActions.saveMilestone,
		saveQueue: MilestoneActions.saveMilestoneQueue,
		saveMany: MilestoneActions.saveManyMilestones,
		saveManyQueue: MilestoneActions.saveManyMilestonesQueue,
		remove: MilestoneActions.removeMilestone,
		removeQueue: MilestoneActions.removeMilestoneQueue,
		restore: MilestoneActions.restoreMilestone,
		restoreQueue: MilestoneActions.restoreMilestoneQueue,
		restoreMany: MilestoneActions.restoreManyMilestones,
		removeMany: MilestoneActions.removeManyMilestones,
		delete: deleteMilestone
	},
	{
		name: 'option',
		plural: 'options',
		clazz: Entities.Option,
		table: 'OPTION',
		fetchOneQueue: OptionActions.fetchOneOptionQueue,
		fetchOneSuccess: OptionActions.fetchOneOptionSuccess,
		fetchOneFailure: OptionActions.fetchOneOptionFailure,
		fetchSuccess: OptionActions.fetchOptionSuccess,
		fetchFailure: OptionActions.fetchOptionFailure,
		saveSuccess: OptionActions.saveOptionSuccess,
		saveFailure: OptionActions.saveOptionFailure,
		saveManySuccess: OptionActions.saveManyOptionsSuccess,
		saveManyFailure: OptionActions.saveManyOptionsFailure,
		removeSuccess: OptionActions.removeOptionSuccess,
		removeFailure: OptionActions.removeOptionFailure,
		restoreSuccess: OptionActions.restoreOptionSuccess,
		restoreFailure: OptionActions.restoreOptionFailure,
		save: OptionActions.saveOption,
		saveQueue: OptionActions.saveOptionQueue,
		saveMany: OptionActions.saveManyOptions,
		saveManyQueue: OptionActions.saveManyOptionsQueue,
		remove: OptionActions.removeOption,
		removeQueue: OptionActions.removeOptionQueue,
		restore: OptionActions.restoreOption,
		restoreQueue: OptionActions.restoreOptionQueue,
		restoreMany: OptionActions.restoreManyOptions,
		removeMany: OptionActions.removeManyOptions,
		delete: deleteOption
	},
	{
		name: 'participant',
		plural: 'participants',
		clazz: Entities.Participant,
		table: 'PARTICIPANT',
		fetchOneQueue: ParticipantActions.fetchOneParticipantQueue,
		fetchOneSuccess: ParticipantActions.fetchOneParticipantSuccess,
		fetchOneFailure: ParticipantActions.fetchOneParticipantFailure,
		fetchSuccess: ParticipantActions.fetchParticipantSuccess,
		fetchFailure: ParticipantActions.fetchParticipantFailure,
		saveSuccess: ParticipantActions.saveParticipantSuccess,
		saveFailure: ParticipantActions.saveParticipantFailure,
		saveManySuccess: ParticipantActions.saveManyParticipantsSuccess,
		saveManyFailure: ParticipantActions.saveManyParticipantsFailure,
		removeSuccess: ParticipantActions.removeParticipantSuccess,
		removeFailure: ParticipantActions.removeParticipantFailure,
		restoreSuccess: ParticipantActions.restoreParticipantSuccess,
		restoreFailure: ParticipantActions.restoreParticipantFailure,
		save: ParticipantActions.saveParticipant,
		saveQueue: ParticipantActions.saveParticipantQueue,
		saveMany: ParticipantActions.saveManyParticipants,
		saveManyQueue: ParticipantActions.saveManyParticipantsQueue,
		remove: ParticipantActions.removeParticipant,
		removeQueue: ParticipantActions.removeParticipantQueue,
		restore: ParticipantActions.restoreParticipant,
		restoreQueue: ParticipantActions.restoreParticipantQueue,
		restoreMany: ParticipantActions.restoreManyParticipants,
		removeMany: ParticipantActions.removeManyParticipants,
		delete: deleteParticipant
	},
	{
		name: 'privilege',
		plural: 'privileges',
		clazz: Entities.Privilege,
		table: 'PRIVILEGES',
		fetchOneQueue: PrivilegeActions.fetchOnePrivilegeQueue,
		fetchOneSuccess: PrivilegeActions.fetchOnePrivilegeSuccess,
		fetchOneFailure: PrivilegeActions.fetchOnePrivilegeFailure,
		fetchSuccess: PrivilegeActions.fetchPrivilegeSuccess,
		fetchFailure: PrivilegeActions.fetchPrivilegeFailure,
		saveSuccess: PrivilegeActions.savePrivilegeSuccess,
		saveFailure: PrivilegeActions.savePrivilegeFailure,
		saveManySuccess: PrivilegeActions.saveManyPrivilegesSuccess,
		saveManyFailure: PrivilegeActions.saveManyPrivilegesFailure,
		removeSuccess: PrivilegeActions.removePrivilegeSuccess,
		removeFailure: PrivilegeActions.removePrivilegeFailure,
		restoreSuccess: PrivilegeActions.restorePrivilegeSuccess,
		restoreFailure: PrivilegeActions.restorePrivilegeFailure,
		save: PrivilegeActions.savePrivilege,
		saveQueue: PrivilegeActions.savePrivilegeQueue,
		saveMany: PrivilegeActions.saveManyPrivileges,
		saveManyQueue: PrivilegeActions.saveManyPrivilegesQueue,
		remove: PrivilegeActions.removePrivilege,
		removeQueue: PrivilegeActions.removePrivilegeQueue,
		restore: PrivilegeActions.restorePrivilege,
		restoreQueue: PrivilegeActions.restorePrivilegeQueue,
		restoreMany: PrivilegeActions.restoreManyPrivileges,
		removeMany: PrivilegeActions.removeManyPrivileges,
		delete: deletePrivilege
	},
	{
		name: 'question',
		plural: 'questions',
		clazz: Entities.Question,
		table: 'QUESTION',
		fetchOneQueue: QuestionActions.fetchOneQuestionQueue,
		fetchOneSuccess: QuestionActions.fetchOneQuestionSuccess,
		fetchOneFailure: QuestionActions.fetchOneQuestionFailure,
		fetchSuccess: QuestionActions.fetchQuestionSuccess,
		fetchFailure: QuestionActions.fetchQuestionFailure,
		saveSuccess: QuestionActions.saveQuestionSuccess,
		saveFailure: QuestionActions.saveQuestionFailure,
		saveManySuccess: QuestionActions.saveManyQuestionsSuccess,
		saveManyFailure: QuestionActions.saveManyQuestionsFailure,
		removeSuccess: QuestionActions.removeQuestionSuccess,
		removeFailure: QuestionActions.removeQuestionFailure,
		restoreSuccess: QuestionActions.restoreQuestionSuccess,
		restoreFailure: QuestionActions.restoreQuestionFailure,
		save: QuestionActions.saveQuestion,
		saveQueue: QuestionActions.saveQuestionQueue,
		saveMany: QuestionActions.saveManyQuestions,
		saveManyQueue: QuestionActions.saveManyQuestionsQueue,
		remove: QuestionActions.removeQuestion,
		removeQueue: QuestionActions.removeQuestionQueue,
		restore: QuestionActions.restoreQuestion,
		restoreQueue: QuestionActions.restoreQuestionQueue,
		restoreMany: QuestionActions.restoreManyQuestions,
		removeMany: QuestionActions.removeManyQuestions,
		delete: deleteQuestion
	},
	{
		name: 'redFlagType',
		plural: 'redFlagTypes',
		clazz: Entities.RedFlagType,
		table: 'RED_FLAG_TYPE',
		fetchOneQueue: RedFlagTypeActions.fetchOneRedFlagTypeQueue,
		fetchOneSuccess: RedFlagTypeActions.fetchOneRedFlagTypeSuccess,
		fetchOneFailure: RedFlagTypeActions.fetchOneRedFlagTypeFailure,
		fetchSuccess: RedFlagTypeActions.fetchRedFlagTypeSuccess,
		fetchFailure: RedFlagTypeActions.fetchRedFlagTypeFailure,
		saveSuccess: RedFlagTypeActions.saveRedFlagTypeSuccess,
		saveFailure: RedFlagTypeActions.saveRedFlagTypeFailure,
		saveManySuccess: RedFlagTypeActions.saveManyRedFlagTypesSuccess,
		saveManyFailure: RedFlagTypeActions.saveManyRedFlagTypesFailure,
		removeSuccess: RedFlagTypeActions.removeRedFlagTypeSuccess,
		removeFailure: RedFlagTypeActions.removeRedFlagTypeFailure,
		restoreSuccess: RedFlagTypeActions.restoreRedFlagTypeSuccess,
		restoreFailure: RedFlagTypeActions.restoreRedFlagTypeFailure,
		save: RedFlagTypeActions.saveRedFlagType,
		saveQueue: RedFlagTypeActions.saveRedFlagTypeQueue,
		saveMany: RedFlagTypeActions.saveManyRedFlagTypes,
		saveManyQueue: RedFlagTypeActions.saveManyRedFlagTypesQueue,
		remove: RedFlagTypeActions.removeRedFlagType,
		removeQueue: RedFlagTypeActions.removeRedFlagTypeQueue,
		restore: RedFlagTypeActions.restoreRedFlagType,
		restoreQueue: RedFlagTypeActions.restoreRedFlagTypeQueue,
		restoreMany: RedFlagTypeActions.restoreManyRedFlagTypes,
		removeMany: RedFlagTypeActions.removeManyRedFlagTypes,
		delete: deleteRedFlagType
	},
	{
		name: 'redFlag',
		plural: 'redFlags',
		clazz: Entities.RedFlag,
		table: 'RED_FLAG',
		fetchOneQueue: RedFlagActions.fetchOneRedFlagQueue,
		fetchOneSuccess: RedFlagActions.fetchOneRedFlagSuccess,
		fetchOneFailure: RedFlagActions.fetchOneRedFlagFailure,
		fetchSuccess: RedFlagActions.fetchRedFlagSuccess,
		fetchFailure: RedFlagActions.fetchRedFlagFailure,
		saveSuccess: RedFlagActions.saveRedFlagSuccess,
		saveFailure: RedFlagActions.saveRedFlagFailure,
		saveManySuccess: RedFlagActions.saveManyRedFlagsSuccess,
		saveManyFailure: RedFlagActions.saveManyRedFlagsFailure,
		removeSuccess: RedFlagActions.removeRedFlagSuccess,
		removeFailure: RedFlagActions.removeRedFlagFailure,
		restoreSuccess: RedFlagActions.restoreRedFlagSuccess,
		restoreFailure: RedFlagActions.restoreRedFlagFailure,
		save: RedFlagActions.saveRedFlag,
		saveQueue: RedFlagActions.saveRedFlagQueue,
		saveMany: RedFlagActions.saveManyRedFlags,
		saveManyQueue: RedFlagActions.saveManyRedFlagsQueue,
		remove: RedFlagActions.removeRedFlag,
		removeQueue: RedFlagActions.removeRedFlagQueue,
		restore: RedFlagActions.restoreRedFlag,
		restoreQueue: RedFlagActions.restoreRedFlagQueue,
		restoreMany: RedFlagActions.restoreManyRedFlags,
		removeMany: RedFlagActions.removeManyRedFlags,
		delete: deleteRedFlag
	},
	{
		name: 'resource',
		plural: 'resources',
		clazz: Entities.Resource,
		table: 'RESOURCE',
		fetchOneQueue: ResourceActions.fetchOneResourceQueue,
		fetchOneSuccess: ResourceActions.fetchOneResourceSuccess,
		fetchOneFailure: ResourceActions.fetchOneResourceFailure,
		fetchSuccess: ResourceActions.fetchResourceSuccess,
		fetchFailure: ResourceActions.fetchResourceFailure,
		saveSuccess: ResourceActions.saveResourceSuccess,
		saveFailure: ResourceActions.saveResourceFailure,
		saveManySuccess: ResourceActions.saveManyResourcesSuccess,
		saveManyFailure: ResourceActions.saveManyResourcesFailure,
		removeSuccess: ResourceActions.removeResourceSuccess,
		removeFailure: ResourceActions.removeResourceFailure,
		restoreSuccess: ResourceActions.restoreResourceSuccess,
		restoreFailure: ResourceActions.restoreResourceFailure,
		save: ResourceActions.saveResource,
		saveQueue: ResourceActions.saveResourceQueue,
		saveMany: ResourceActions.saveManyResources,
		saveManyQueue: ResourceActions.saveManyResourcesQueue,
		remove: ResourceActions.removeResource,
		removeQueue: ResourceActions.removeResourceQueue,
		restore: ResourceActions.restoreResource,
		restoreQueue: ResourceActions.restoreResourceQueue,
		restoreMany: ResourceActions.restoreManyResources,
		removeMany: ResourceActions.removeManyResources,
		delete: deleteResource
	},
	{
		name: 'referral',
		plural: 'referrals',
		clazz: Entities.Referral,
		table: 'REFERRAL',
		fetchOneQueue: ReferralActions.fetchOneReferralQueue,
		fetchOneSuccess: ReferralActions.fetchOneReferralSuccess,
		fetchOneFailure: ReferralActions.fetchOneReferralFailure,
		fetchSuccess: ReferralActions.fetchReferralSuccess,
		fetchFailure: ReferralActions.fetchReferralFailure,
		saveSuccess: ReferralActions.saveReferralSuccess,
		saveFailure: ReferralActions.saveReferralFailure,
		saveManySuccess: ReferralActions.saveManyReferralsSuccess,
		saveManyFailure: ReferralActions.saveManyReferralsFailure,
		removeSuccess: ReferralActions.removeReferralSuccess,
		removeFailure: ReferralActions.removeReferralFailure,
		restoreSuccess: ReferralActions.restoreReferralSuccess,
		restoreFailure: ReferralActions.restoreReferralFailure,
		save: ReferralActions.saveReferral,
		saveQueue: ReferralActions.saveReferralQueue,
		saveMany: ReferralActions.saveManyReferrals,
		saveManyQueue: ReferralActions.saveManyReferralsQueue,
		remove: ReferralActions.removeReferral,
		removeQueue: ReferralActions.removeReferralQueue,
		restore: ReferralActions.restoreReferral,
		restoreQueue: ReferralActions.restoreReferralQueue,
		restoreMany: ReferralActions.restoreManyReferrals,
		removeMany: ReferralActions.removeManyReferrals,
		delete: deleteReferral
	},
	{
		name: 'role',
		plural: 'roles',
		clazz: Entities.Role,
		table: 'ROLES',
		fetchOneQueue: RoleActions.fetchOneRoleQueue,
		fetchOneSuccess: RoleActions.fetchOneRoleSuccess,
		fetchOneFailure: RoleActions.fetchOneRoleFailure,
		fetchSuccess: RoleActions.fetchRoleSuccess,
		fetchFailure: RoleActions.fetchRoleFailure,
		saveSuccess: RoleActions.saveRoleSuccess,
		saveFailure: RoleActions.saveRoleFailure,
		saveManySuccess: RoleActions.saveManyRolesSuccess,
		saveManyFailure: RoleActions.saveManyRolesFailure,
		removeSuccess: RoleActions.removeRoleSuccess,
		removeFailure: RoleActions.removeRoleFailure,
		restoreSuccess: RoleActions.restoreRoleSuccess,
		restoreFailure: RoleActions.restoreRoleFailure,
		save: RoleActions.saveRole,
		saveQueue: RoleActions.saveRoleQueue,
		saveMany: RoleActions.saveManyRoles,
		saveManyQueue: RoleActions.saveManyRolesQueue,
		remove: RoleActions.removeRole,
		removeQueue: RoleActions.removeRoleQueue,
		restore: RoleActions.restoreRole,
		restoreQueue: RoleActions.restoreRoleQueue,
		restoreMany: RoleActions.restoreManyRoles,
		removeMany: RoleActions.removeManyRoles,
		delete: deleteRole
	},
	{
		name: 'task',
		plural: 'tasks',
		clazz: Entities.Task,
		table: 'TASK',
		fetchOneQueue: TaskActions.fetchOneTaskQueue,
		fetchOneSuccess: TaskActions.fetchOneTaskSuccess,
		fetchOneFailure: TaskActions.fetchOneTaskFailure,
		fetchSuccess: TaskActions.fetchTaskSuccess,
		fetchFailure: TaskActions.fetchTaskFailure,
		saveSuccess: TaskActions.saveTaskSuccess,
		saveFailure: TaskActions.saveTaskFailure,
		saveManySuccess: TaskActions.saveManyTasksSuccess,
		saveManyFailure: TaskActions.saveManyTasksFailure,
		removeSuccess: TaskActions.removeTaskSuccess,
		removeFailure: TaskActions.removeTaskFailure,
		restoreSuccess: TaskActions.restoreTaskSuccess,
		restoreFailure: TaskActions.restoreTaskFailure,
		save: TaskActions.saveTask,
		saveQueue: TaskActions.saveTaskQueue,
		saveMany: TaskActions.saveManyTasks,
		saveManyQueue: TaskActions.saveManyTasksQueue,
		remove: TaskActions.removeTask,
		removeQueue: TaskActions.removeTaskQueue,
		restore: TaskActions.restoreTask,
		restoreQueue: TaskActions.restoreTaskQueue,
		restoreMany: TaskActions.restoreManyTasks,
		removeMany: TaskActions.removeManyTasks,
		delete: deleteTask
	},
	{
		name: 'templateTask',
		plural: 'templateTasks',
		clazz: Entities.TemplateTask,
		table: 'TEMPLATE_TASK',
		fetchOneQueue: TemplateTaskActions.fetchOneTemplateTaskQueue,
		fetchOneSuccess: TemplateTaskActions.fetchOneTemplateTaskSuccess,
		fetchOneFailure: TemplateTaskActions.fetchOneTemplateTaskFailure,
		fetchSuccess: TemplateTaskActions.fetchTemplateTaskSuccess,
		fetchFailure: TemplateTaskActions.fetchTemplateTaskFailure,
		saveSuccess: TemplateTaskActions.saveTemplateTaskSuccess,
		saveFailure: TemplateTaskActions.saveTemplateTaskFailure,
		saveManySuccess: TemplateTaskActions.saveManyTemplateTasksSuccess,
		saveManyFailure: TemplateTaskActions.saveManyTemplateTasksFailure,
		removeSuccess: TemplateTaskActions.removeTemplateTaskSuccess,
		removeFailure: TemplateTaskActions.removeTemplateTaskFailure,
		restoreSuccess: TemplateTaskActions.restoreTemplateTaskSuccess,
		restoreFailure: TemplateTaskActions.restoreTemplateTaskFailure,
		save: TemplateTaskActions.saveTemplateTask,
		saveQueue: TemplateTaskActions.saveTemplateTaskQueue,
		saveMany: TemplateTaskActions.saveManyTemplateTasks,
		saveManyQueue: TemplateTaskActions.saveManyTemplateTasksQueue,
		remove: TemplateTaskActions.removeTemplateTask,
		removeQueue: TemplateTaskActions.removeTemplateTaskQueue,
		restore: TemplateTaskActions.restoreTemplateTask,
		restoreQueue: TemplateTaskActions.restoreTemplateTaskQueue,
		restoreMany: TemplateTaskActions.restoreManyTemplateTasks,
		removeMany: TemplateTaskActions.removeManyTemplateTasks,
		delete: deleteTemplateTask
	},
	{
		name: 'timeOff',
		plural: 'timeOffs',
		clazz: Entities.TimeOff,
		table: 'TIME_OFF',
		fetchOneQueue: TimeOffActions.fetchOneTimeOffQueue,
		fetchOneSuccess: TimeOffActions.fetchOneTimeOffSuccess,
		fetchOneFailure: TimeOffActions.fetchOneTimeOffFailure,
		fetchSuccess: TimeOffActions.fetchTimeOffSuccess,
		fetchFailure: TimeOffActions.fetchTimeOffFailure,
		saveSuccess: TimeOffActions.saveTimeOffSuccess,
		saveFailure: TimeOffActions.saveTimeOffFailure,
		saveManySuccess: TimeOffActions.saveManyTimeOffsSuccess,
		saveManyFailure: TimeOffActions.saveManyTimeOffsFailure,
		removeSuccess: TimeOffActions.removeTimeOffSuccess,
		removeFailure: TimeOffActions.removeTimeOffFailure,
		restoreSuccess: TimeOffActions.restoreTimeOffSuccess,
		restoreFailure: TimeOffActions.restoreTimeOffFailure,
		save: TimeOffActions.saveTimeOff,
		saveQueue: TimeOffActions.saveTimeOffQueue,
		saveMany: TimeOffActions.saveManyTimeOffs,
		saveManyQueue: TimeOffActions.saveManyTimeOffsQueue,
		remove: TimeOffActions.removeTimeOff,
		removeQueue: TimeOffActions.removeTimeOffQueue,
		restore: TimeOffActions.restoreTimeOff,
		restoreQueue: TimeOffActions.restoreTimeOffQueue,
		restoreMany: TimeOffActions.restoreManyTimeOffs,
		removeMany: TimeOffActions.removeManyTimeOffs,
		delete: deleteTimeOff
	},
	{
		name: 'transaction',
		plural: 'transactions',
		clazz: Entities.Transaction,
		table: 'TRANSACTION',
		fetchOneQueue: TransactionActions.fetchOneTransactionQueue,
		fetchOneSuccess: TransactionActions.fetchOneTransactionSuccess,
		fetchOneFailure: TransactionActions.fetchOneTransactionFailure,
		fetchSuccess: TransactionActions.fetchTransactionSuccess,
		fetchFailure: TransactionActions.fetchTransactionFailure,
		saveSuccess: TransactionActions.saveTransactionSuccess,
		saveFailure: TransactionActions.saveTransactionFailure,
		saveManySuccess: TransactionActions.saveManyTransactionsSuccess,
		saveManyFailure: TransactionActions.saveManyTransactionsFailure,
		removeSuccess: TransactionActions.removeTransactionSuccess,
		removeFailure: TransactionActions.removeTransactionFailure,
		restoreSuccess: TransactionActions.restoreTransactionSuccess,
		restoreFailure: TransactionActions.restoreTransactionFailure,
		save: TransactionActions.saveTransaction,
		saveQueue: TransactionActions.saveTransactionQueue,
		saveMany: TransactionActions.saveManyTransactions,
		saveManyQueue: TransactionActions.saveManyTransactionsQueue,
		remove: TransactionActions.removeTransaction,
		removeQueue: TransactionActions.removeTransactionQueue,
		restore: TransactionActions.restoreTransaction,
		restoreQueue: TransactionActions.restoreTransactionQueue,
		restoreMany: TransactionActions.restoreManyTransactions,
		removeMany: TransactionActions.removeManyTransactions,
		delete: deleteTransaction
	},
	{
		name: 'user',
		plural: 'users',
		clazz: Entities.User,
		table: 'USERS',
		fetchOneQueue: UserActions.fetchOneUserQueue,
		fetchOneSuccess: UserActions.fetchOneUserSuccess,
		fetchOneFailure: UserActions.fetchOneUserFailure,
		fetchSuccess: UserActions.fetchUserSuccess,
		fetchFailure: UserActions.fetchUserFailure,
		saveSuccess: UserActions.saveUserSuccess,
		saveFailure: UserActions.saveUserFailure,
		saveManySuccess: UserActions.saveManyUsersSuccess,
		saveManyFailure: UserActions.saveManyUsersFailure,
		removeSuccess: UserActions.removeUserSuccess,
		removeFailure: UserActions.removeUserFailure,
		restoreSuccess: UserActions.restoreUserSuccess,
		restoreFailure: UserActions.restoreUserFailure,
		save: UserActions.saveUser,
		saveQueue: UserActions.saveUserQueue,
		saveMany: UserActions.saveManyUsers,
		saveManyQueue: UserActions.saveManyUsersQueue,
		remove: UserActions.removeUser,
		removeQueue: UserActions.removeUserQueue,
		restore: UserActions.restoreUser,
		restoreQueue: UserActions.restoreUserQueue,
		restoreMany: UserActions.restoreManyUsers,
		removeMany: UserActions.removeManyUsers,
		delete: deleteUser
	}
];

export default ENTITIES;